import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Catalog from "./pages/Catalog";
import ItemDetail from "./pages/ItemDetail";
import TryOn from "./pages/TryOn";
import TryOnLanding from "./pages/TryOnLanding";
import LookPreview from "./pages/LookPreview";
import WaitlistAdmin from "./pages/WaitlistAdmin";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Pricing from "./pages/Pricing";
import Retouch from "./pages/Retouch";
import Collab from "./pages/Collab";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App relative">
      <div className="grain-overlay" />
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Catalog />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/retouch" element={<Retouch />} />
          <Route path="/collab" element={<Collab />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/try-on" element={<TryOnLanding />} />
          <Route path="/look/:category" element={<LookPreview />} />
          <Route path="/admin/waitlist" element={<WaitlistAdmin />} />
          <Route path="/catalog" element={<Navigate to="/" replace />} />
          <Route path="/catalog/:id" element={<ItemDetail />} />
          <Route path="/try-on/:id" element={<TryOn />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
